import { render, staticRenderFns } from "./shakeout-checkout.vue?vue&type=template&id=bf4d2f06"
import script from "./shakeout-checkout.vue?vue&type=script&lang=js"
export * from "./shakeout-checkout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports